import { LoaderActions } from '@store/loaders'
import { SetSubscriptionAction } from '@store/reducers/subscription/actions'
import {
  CancelSubscriptionSuccess,
  GeneralErrorNotification,
} from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import type { SubscriptionState } from '../types'

export function* braintreeCancel() {
  yield put(LoaderActions.set('braintree_cancel'))
  try {
    const data: SubscriptionState = yield call(
      NestClient.subscription.braintreeCancel
    )
    yield put(SetSubscriptionAction(data))
    yield put(CancelSubscriptionSuccess)
  } catch (err) {
    console.error('Braintree cancel error', err)
    yield put(GeneralErrorNotification)
  } finally {
    yield put(LoaderActions.unset('braintree_cancel'))
  }
}
